import { render, staticRenderFns } from "./TotalCounter.vue?vue&type=template&id=b13a4008&scoped=true"
import script from "./TotalCounter.vue?vue&type=script&lang=ts"
export * from "./TotalCounter.vue?vue&type=script&lang=ts"
import style0 from "./TotalCounter.vue?vue&type=style&index=0&id=b13a4008&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13a4008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b13a4008')) {
      api.createRecord('b13a4008', component.options)
    } else {
      api.reload('b13a4008', component.options)
    }
    module.hot.accept("./TotalCounter.vue?vue&type=template&id=b13a4008&scoped=true", function () {
      api.rerender('b13a4008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TotalCounter.vue"
export default component.exports